<template>
    <div class="fill-height">
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-card class="elevation-12" outlined width="500">
                    <v-toolbar flat>
                        <v-toolbar-title class="gray--text to-center" style="font-size:22px">{{ $t('Вход в систему') }}</v-toolbar-title>
                    </v-toolbar>

                    <v-card-text class="pb-0">
                        <v-form ref="signInForm">
                            <v-text-field
                                outlined
                                color="gray"
                                prepend-inner-icon="account_circle"
                                v-model="email"
                                :label="$t('E-mail')"
                                :rules="emailRules"
                                validate-on-blur
                            ></v-text-field>
                            <v-text-field
                                outlined
                                color="gray"
                                v-model="password"
                                prepend-inner-icon="lock"
                                :label="$t('Пароль')"
                                :rules="[PasswordRequired]"
                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                @keyup.enter="login"
                            ></v-text-field>

                            <span style="font-size: 14px" class="red--text">{{ $t(message) }}</span>

                            <!-- lock -->
                        </v-form>
                        <p class="to-center custom-link mt-4 mb-3">
                            <span @click="openForgotPasswordPage" class="gray--text" style="cursor:pointer">{{ $t('Забыли пароль?') }}</span>
                        </p>
                        <v-btn color="info" height="50px" class="block mt-5" @click="login">{{ $t('Войти') }}</v-btn>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                    </v-card-actions>
                </v-card>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import FormValidator from '../../mixins/FormValidator';
import { LocaleService } from '@/services/storage.service';
export default {
    data: () => ({
        email: null,
        password: null,
        message: null,
        showPassword: false
    }),
    mixins: [FormValidator],
    methods: {
        ...mapActions('auth', ['signIn']),
        async login() {
            if (!this.$refs.signInForm.validate()) return;
            const payload = { email: this.email, password: this.password };
            let result = await this.signIn(payload);

            switch (result.message) {
                case 'msgNotCorrectUsernameOrPassword':
                    this.message =
                        'Неверный логин или пароль. Пожалуйста, проверьте правильность введенных данных. Если Вы забыли пароль, воспользуйтесь восстановлением пароля';

                    break;
                case 'UserBlockedOrNotActivated':
                    this.message = 'Учетная запись заблокирована. Обратитесь в ТОО «АлТС»';
                    break;

                default:
                    break;
            }

            if (result.successfull) {
                this.$store.commit('auth/setToken', result.accessToken.token);
                this.$store.commit('auth/setLogin', this.email);
                this.$store.commit('auth/setTokenExpirationDate', result.accessToken.expires);
                await this.$store.dispatch('permissions/getUserPermissions');
                //await this.$store.dispatch('users/getServOrg');
                await this.$store.dispatch('users/getUserHeader');
                if (this.inFrame) {
                    this.email = null;
                    this.password = null;
                    //откроем главную страницу в новой вкладке
                    window.open(window.location.origin);
                } else {
                    this.$router.replace('/');
                }
            }
        },
        openForgotPasswordPage() {
            if (this.inFrame) {
                window.open(window.location.origin + '/ForgotPassword');
            } else {
                this.$router.push({ name: 'ForgotPassword' });
            }
        }
    },
    computed: {
        inFrame() {
            try {
                return window.self !== window.top;
            } catch (e) {
                return false;
            }
        }
    },
    async mounted() {
        // const restorePasswordLinkExpiresAt =  ["1", "h"];
        // let expiresAt = await moment().add(restorePasswordLinkExpiresAt[0], restorePasswordLinkExpiresAt[1]).toDate();
        // const urlExpiresAt2 = moment(expiresAt).locale("kk").format("LLL");
        //переключим насильно на русский язык если форма отображается во фрейме
        if (this.inFrame) {
            const locale = 'ru';
            if (locale === this.$i18n.locale) return;
            this.$i18n.locale = locale;
            LocaleService.setLocale(locale);
        }
        this.$watch(
            '$i18n.locale',
            (newLocale, oldLocale) => {
                if (newLocale === oldLocale) {
                    return;
                }
                this.$refs.signInForm.resetValidation();
            },
            { immediate: true }
        );
    }
};
</script>

<style>
.block {
    display: block;
    width: 100%;
    border: none;
    background-color: #4caf50;
    padding: 14px 28px;
    font-size: 16px;
    text-align: center;
}
.to-center {
    display: block;
    width: 100%;
    text-align: center;
}
.custom-link {
    font-size: 16px;
}
</style>
